import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as Actions from "../flex/Actions";



export default function AuthEffectComponent() {

    const loginConnection = useSelector(state => state.loginConnection)
    const logoutConnection = useSelector(state => state.logoutConnection)
    const dispatch = useDispatch();

    useEffect(() => {
        // console.log(loginConnection)
        if(loginConnection.meta.status === Actions.statusEnum.SUCCESS && loginConnection.payload.response === "success"){
            dispatch(Actions.data.session(true));
        }else{
            dispatch(Actions.data.session(false));
        }
        if(loginConnection.meta.status === Actions.statusEnum.FAILURE || loginConnection.meta.status === Actions.statusEnum.ERROR){
            dispatch(Actions.data.session(false));
        }
    }, [loginConnection, dispatch]);


    useEffect(() => {
        if(logoutConnection.meta.status === Actions.statusEnum.SUCCESS){
            dispatch(Actions.data.session(false));
        }
        if(logoutConnection.meta.status === Actions.statusEnum.FAILURE || loginConnection.meta.status === Actions.statusEnum.ERROR){
            dispatch(Actions.data.session(true));
        }
    },[logoutConnection, loginConnection.meta.status, dispatch])


    return null
}